<template>
    <div class="e404">
        {{ text || $t('common.page not found') }}
    </div>
</template>

<script>
    import Vue from 'vue';
    export default Vue.extend({
        name: "e404",
        props: {
            text: {
                type: String,
                require: false,
                default: undefined
            }
        }
    })
</script>

<style scoped>
    .e404 {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2em;
        color: #c7c7c7;
    }
</style>